(function () {
  const sections = document.querySelectorAll('[data-sm-product-form]');
  sections.forEach(init);

  function init(form) {
    const section = form.closest('[data-sm-product-scope]') || form.closest('[data-section-id]');
    const productJson = form.querySelector('[data-sm-product-json]');
    if (!productJson) return;
    let product;
    try { product = JSON.parse(productJson.textContent); } catch (e) { return; }

    const swatches = form.querySelectorAll('[data-sm-swatch]');

    function centerActiveSwatch(btn) {
      if (!btn) return;
      const container = btn.closest('.sm-pd-card__swatches');
      if (!container || container.scrollWidth <= container.clientWidth) return;
      const target = btn.offsetLeft - (container.clientWidth - btn.offsetWidth) / 2;
      container.scrollTo({ left: target, behavior: 'smooth' });
    }

    // Drag-to-scroll for the swatch row (desktop). Mobile uses native touch scroll.
    // Only treat as "dragging" once the pointer moves past the threshold, so a plain
    // click on a swatch isn't swallowed by the capture / pointer-events:none handling.
    const SM_DRAG_THRESHOLD = 4;
    form.querySelectorAll('.sm-pd-card__swatches').forEach((container) => {
      let isDown = false, dragging = false, startX = 0, startScroll = 0, pointerId = null;
      container.addEventListener('pointerdown', (e) => {
        if (e.pointerType === 'touch') return;
        isDown = true;
        dragging = false;
        startX = e.clientX;
        startScroll = container.scrollLeft;
        pointerId = e.pointerId;
      });
      container.addEventListener('pointermove', (e) => {
        if (!isDown) return;
        const dx = e.clientX - startX;
        if (!dragging) {
          if (Math.abs(dx) < SM_DRAG_THRESHOLD) return;
          dragging = true;
          container.classList.add('is-dragging');
          try { container.setPointerCapture(pointerId); } catch (_) {}
        }
        container.scrollLeft = startScroll - dx;
      });
      const endDrag = () => {
        if (!isDown) return;
        isDown = false;
        if (dragging) {
          container.classList.remove('is-dragging');
          try { container.releasePointerCapture(pointerId); } catch (_) {}
        }
      };
      container.addEventListener('pointerup', endDrag);
      container.addEventListener('pointercancel', endDrag);
      container.addEventListener('pointerleave', endDrag);
      // suppress the swatch-selection click only when it followed an actual drag
      container.addEventListener('click', (e) => {
        if (dragging) { e.preventDefault(); e.stopPropagation(); }
        dragging = false;
      }, true);
      // prevent native image drag ghost
      container.querySelectorAll('img').forEach(img => img.setAttribute('draggable', 'false'));
    });
    const idInput = form.querySelector('[data-sm-variant-id]');
    const priceValue = form.querySelector('[data-sm-price-value]');
    const priceCompare = form.querySelector('[data-sm-price-compare]');
    const optValues = form.querySelectorAll('[data-sm-opt-value]');
    const addBtn = form.querySelector('[data-sm-add]');
    const addText = form.querySelector('[data-sm-add-text]');
    const addSpinner = form.querySelector('[data-sm-add-spinner]');
    const gallery = section.querySelector('[data-sm-gallery]');
    const track = section.querySelector('[data-sm-gallery-track]');
    const dots = section.querySelectorAll('[data-sm-gallery-track] ~ [data-sm-dots] .sm-pd-gallery__dot, [data-sm-dots] .sm-pd-gallery__dot');
    const prev = section.querySelector('[data-sm-prev]');
    const next = section.querySelector('[data-sm-next]');

    function formatMoney(cents) {
      try {
        return new Intl.NumberFormat(document.documentElement.lang || 'en', {
          style: 'currency',
          currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || 'JPY',
          maximumFractionDigits: 0
        }).format(cents / 100);
      } catch (e) {
        return '¥' + Math.round(cents / 100).toLocaleString();
      }
    }

    function findVariant(selections) {
      return product.variants.find(v => {
        return (!selections[0] || v.option1 === selections[0])
          && (!selections[1] || v.option2 === selections[1])
          && (!selections[2] || v.option3 === selections[2]);
      });
    }

    function currentSelections() {
      const selections = [];
      swatches.forEach(s => {
        if (s.classList.contains('is-selected')) {
          const pos = parseInt(s.dataset.optionPosition, 10) - 1;
          selections[pos] = s.dataset.optionValue;
        }
      });
      // fill in remaining positions from existing variant
      const currentId = parseInt(idInput.value, 10);
      const currentVariant = product.variants.find(v => v.id === currentId);
      if (currentVariant) {
        [currentVariant.option1, currentVariant.option2, currentVariant.option3].forEach((o, i) => {
          if (!selections[i] && o) selections[i] = o;
        });
      }
      return selections;
    }

    function updatePriceUI(variant) {
      if (!variant) return;
      if (priceValue) priceValue.textContent = formatMoney(variant.price);
      if (priceCompare) {
        if (variant.compare_at_price && variant.compare_at_price > variant.price) {
          priceCompare.textContent = formatMoney(variant.compare_at_price);
          priceCompare.hidden = false;
        } else {
          priceCompare.hidden = true;
        }
      }
    }

    const labels = {
      add: addBtn?.dataset.labelAdd || 'Add to bag',
      soldOut: addBtn?.dataset.labelSoldOut || 'Sold out',
      unavailable: addBtn?.dataset.labelUnavailable || 'Unavailable',
      adding: addBtn?.dataset.labelAdding || 'Adding…',
      tryAgain: addBtn?.dataset.labelTryAgain || 'Try again'
    };

    function updateAvailability(variant) {
      if (!variant || !variant.available) {
        addBtn.disabled = true;
        if (addText) addText.textContent = variant ? labels.soldOut : labels.unavailable;
      } else {
        addBtn.disabled = false;
        if (addText) addText.textContent = labels.add;
      }
    }

    let colorMap = null;
    try {
      const mapEl = form.querySelector('[data-sm-color-map]');
      if (mapEl) colorMap = JSON.parse(mapEl.textContent);
    } catch (e) {}

    function updateOptLabels(variant) {
      if (!variant) return;
      optValues.forEach(el => {
        const pos = parseInt(el.dataset.optPosition, 10);
        const key = ['option1','option2','option3'][pos - 1];
        const raw = variant[key] || '';
        if (el.hasAttribute('data-sm-color-value') && colorMap && colorMap[raw]) {
          el.textContent = colorMap[raw];
        } else {
          el.textContent = raw;
        }
      });
    }

    function scrollToMediaId(mediaId) {
      if (!track || !mediaId) return;
      const slide = track.querySelector(`[data-media-id="${mediaId}"]`);
      if (!slide) return;
      const trackRect = track.getBoundingClientRect();
      const slideRect = slide.getBoundingClientRect();
      track.scrollTo({ left: track.scrollLeft + (slideRect.left - trackRect.left), behavior: 'smooth' });
      updateActiveDot(mediaId);
    }

    const DOT_SIZE = 8;
    const DOT_GAP = 8;
    const DOT_STRIDE = DOT_SIZE + DOT_GAP;
    const DOT_WINDOW = 7;
    function updateActiveDot(mediaId) {
      const dotsTrack = section.querySelector('[data-sm-dots-track]');
      const allDots = section.querySelectorAll('.sm-pd-gallery__dot');
      if (!allDots.length) return;
      let activeIdx = -1;
      allDots.forEach((d, i) => {
        if (d.dataset.mediaId === String(mediaId)) activeIdx = i;
      });
      if (activeIdx < 0) return;
      const visibleCount = Math.min(allDots.length, DOT_WINDOW);
      const viewport = dotsTrack ? dotsTrack.parentElement : null;
      if (viewport) {
        const innerW = visibleCount * DOT_SIZE + Math.max(0, visibleCount - 1) * DOT_GAP;
        viewport.style.width = (innerW + 16) + 'px';
      }
      const half = Math.floor(DOT_WINDOW / 2);
      const maxStart = Math.max(0, allDots.length - DOT_WINDOW);
      const windowStart = Math.max(0, Math.min(maxStart, activeIdx - half));
      const windowEnd = windowStart + DOT_WINDOW;
      allDots.forEach((d, i) => {
        d.classList.toggle('is-active', i === activeIdx);
        if (i >= windowStart && i < windowEnd) d.removeAttribute('data-dot-state');
        else d.dataset.dotState = 'far';
      });
      if (!dotsTrack) return;
      dotsTrack.style.transform = 'translateX(' + (-windowStart * DOT_STRIDE) + 'px)';
    }

    let syncTimer = null;
    function scheduleSync(mediaId) {
      if (syncTimer) clearTimeout(syncTimer);
      syncTimer = setTimeout(() => syncVariantFromMedia(mediaId), 160);
    }

    function findVariantForMedia(mediaId) {
      if (!mediaId) return null;
      const matching = product.variants.filter(v => v.featured_media && String(v.featured_media.id) === String(mediaId));
      if (!matching.length) return null;
      const cur = product.variants.find(v => v.id === parseInt(idInput.value, 10));
      if (!cur) return matching[0];
      let best = matching[0], bestScore = -1;
      for (const v of matching) {
        let score = 0;
        for (let i = 1; i <= 3; i++) {
          if (cur['option' + i] && v['option' + i] === cur['option' + i]) score++;
        }
        if (score > bestScore) { bestScore = score; best = v; }
      }
      return best;
    }
    function resolveMediaVariant(mediaId) {
      let v = findVariantForMedia(mediaId);
      if (v || !track) return v;
      const slides = track.querySelectorAll('.sm-pd-gallery__slide');
      let curIdx = -1;
      for (let i = 0; i < slides.length; i++) {
        if (slides[i].dataset.mediaId === String(mediaId)) { curIdx = i; break; }
      }
      if (curIdx < 0) return null;
      for (let j = curIdx - 1; j >= 0; j--) {
        v = findVariantForMedia(slides[j].dataset.mediaId);
        if (v) return v;
      }
      for (let j = curIdx + 1; j < slides.length; j++) {
        v = findVariantForMedia(slides[j].dataset.mediaId);
        if (v) return v;
      }
      return null;
    }
    function syncVariantFromMedia(mediaId) {
      if (!mediaId) return;
      const variant = resolveMediaVariant(mediaId);
      if (!variant) return;
      if (parseInt(idInput.value, 10) === variant.id) return;
      idInput.value = variant.id;
      // update swatches selection to match this variant
      product.options.forEach((optName, idx) => {
        const pos = idx + 1;
        const val = variant['option' + pos];
        form.querySelectorAll(`[data-sm-swatch][data-option-position="${pos}"]`).forEach(b => {
          const isMatch = b.dataset.optionValue === val;
          b.classList.toggle('is-selected', isMatch);
          b.setAttribute('aria-pressed', isMatch ? 'true' : 'false');
          if (isMatch) centerActiveSwatch(b);
        });
      });
      updatePriceUI(variant);
      updateAvailability(variant);
      updateOptLabels(variant);
      const url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      history.replaceState({}, '', url.toString());
    }

    function updateGalleryForVariant(variant) {
      if (!variant || !variant.featured_media) return;
      scrollToMediaId(variant.featured_media.id);
    }

    swatches.forEach(btn => {
      btn.addEventListener('click', () => {
        const pos = btn.dataset.optionPosition;
        form.querySelectorAll(`[data-sm-swatch][data-option-position="${pos}"]`).forEach(b => {
          b.classList.remove('is-selected');
          b.setAttribute('aria-pressed', 'false');
        });
        btn.classList.add('is-selected');
        btn.setAttribute('aria-pressed', 'true');
        centerActiveSwatch(btn);

        const variant = findVariant(currentSelections());
        if (variant) {
          idInput.value = variant.id;
          updatePriceUI(variant);
          updateAvailability(variant);
          updateOptLabels(variant);
          updateGalleryForVariant(variant);
          const url = new URL(window.location.href);
          url.searchParams.set('variant', variant.id);
          history.replaceState({}, '', url.toString());
        }
      });
    });

    // Gallery nav
    if (prev && track) prev.addEventListener('click', () => track.scrollBy({ left: -track.clientWidth, behavior: 'smooth' }));
    if (next && track) next.addEventListener('click', () => track.scrollBy({ left: track.clientWidth, behavior: 'smooth' }));

    // Mouse drag-to-swipe (desktop)
    if (track) {
      let isDown = false, startX = 0, startScroll = 0, moved = 0;
      track.addEventListener('pointerdown', (e) => {
        if (e.pointerType === 'touch') return;
        isDown = true;
        moved = 0;
        startX = e.clientX;
        startScroll = track.scrollLeft;
        track.classList.add('is-dragging');
        track.setPointerCapture(e.pointerId);
      });
      track.addEventListener('pointermove', (e) => {
        if (!isDown) return;
        const dx = e.clientX - startX;
        moved = Math.abs(dx);
        track.scrollLeft = startScroll - dx;
      });
      const endDrag = (e) => {
        if (!isDown) return;
        isDown = false;
        track.classList.remove('is-dragging');
        try { track.releasePointerCapture(e.pointerId); } catch (_) {}
        // snap to closest slide
        const slides = track.querySelectorAll('.sm-pd-gallery__slide');
        const trackRect = track.getBoundingClientRect();
        let best = null, bestDist = Infinity;
        slides.forEach(s => {
          const r = s.getBoundingClientRect();
          const dist = Math.abs(r.left - trackRect.left);
          if (dist < bestDist) { bestDist = dist; best = s; }
        });
        if (best) {
          const r = best.getBoundingClientRect();
          track.scrollTo({ left: track.scrollLeft + (r.left - trackRect.left), behavior: 'smooth' });
          updateActiveDot(best.dataset.mediaId);
        }
      };
      track.addEventListener('pointerup', endDrag);
      track.addEventListener('pointercancel', endDrag);
      track.addEventListener('pointerleave', endDrag);
      // prevent click on image after a real drag
      track.addEventListener('click', (e) => {
        if (moved > 6) { e.preventDefault(); e.stopPropagation(); }
      }, true);
      // prevent native image drag ghost
      track.querySelectorAll('img').forEach(img => img.setAttribute('draggable', 'false'));
    }

    section.querySelectorAll('.sm-pd-gallery__dot').forEach(dot => {
      dot.addEventListener('click', () => scrollToMediaId(dot.dataset.mediaId));
    });

    {
      const initialDot = section.querySelector('.sm-pd-gallery__dot.is-active') || section.querySelector('.sm-pd-gallery__dot');
      if (initialDot) updateActiveDot(initialDot.dataset.mediaId);

      // On initial load, scroll gallery to the current variant's featured media
      // so the preview image stays in sync with the selected swatches.
      const currentId = parseInt(idInput.value, 10);
      const currentVariant = product.variants.find(v => v.id === currentId);
      if (currentVariant && currentVariant.featured_media && track) {
        const targetSlide = track.querySelector('[data-media-id="' + currentVariant.featured_media.id + '"]');
        if (targetSlide) {
          // Jump without smooth scroll on init to avoid visible animation on page load.
          const trackRect = track.getBoundingClientRect();
          const slideRect = targetSlide.getBoundingClientRect();
          track.scrollLeft = track.scrollLeft + (slideRect.left - trackRect.left);
          updateActiveDot(currentVariant.featured_media.id);
        }
      }
    }

    // Sync active dot on scroll; debounce variant sync until scroll settles
    if (track) {
      let scrollStopTimer = null;
      track.addEventListener('scroll', () => {
        const slides = track.querySelectorAll('.sm-pd-gallery__slide');
        const trackRect = track.getBoundingClientRect();
        let active = slides[0];
        let best = Infinity;
        slides.forEach(s => {
          const r = s.getBoundingClientRect();
          const dist = Math.abs(r.left - trackRect.left);
          if (dist < best) { best = dist; active = s; }
        });
        if (active) updateActiveDot(active.dataset.mediaId);
        if (scrollStopTimer) clearTimeout(scrollStopTimer);
        scrollStopTimer = setTimeout(() => {
          if (active) syncVariantFromMedia(active.dataset.mediaId);
        }, 140);
      }, { passive: true });
    }

    // Add-to-cart AJAX
    const addUrl = form.getAttribute('action') || '/cart/add';
    const addJsUrl = addUrl.replace(/\/cart\/add(\/?)$/, '/cart/add.js');
    const cartUrl = form.querySelector('input[name="return_to"]')?.value || '/cart';

    function showLoading() {
      if (addBtn.getAttribute('aria-disabled') === 'true') return false;
      addBtn.setAttribute('aria-disabled', 'true');
      addBtn.classList.add('loading');
      if (addSpinner) addSpinner.hidden = false;
      return true;
    }
    function hideLoading() {
      addBtn.disabled = false;
      addBtn.removeAttribute('aria-disabled');
      addBtn.classList.remove('loading');
      if (addSpinner) addSpinner.hidden = true;
    }

    addBtn.addEventListener('click', () => {
      if (addBtn.disabled) return;
      showLoading();
      setTimeout(hideLoading, 4000);
    }, true);

    ['cart:refresh', 'cart:open', 'cart:updated', 'qikify:cart:opened', 'qikify:cart:added', 'ajaxCart.afterCartLoad'].forEach(evt => {
      document.addEventListener(evt, hideLoading);
      window.addEventListener(evt, hideLoading);
    });

    form.addEventListener('submit', async (e) => {
      e.preventDefault();
      if (!showLoading()) return;
      addBtn.disabled = true;
      const origLabel = addText ? addText.textContent : '';
      if (addText) addText.textContent = labels.adding;
      try {
        const res = await fetch(addJsUrl, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ id: parseInt(idInput.value, 10), quantity: 1 })
        });
        if (!res.ok) throw new Error('Add to cart failed');
        document.dispatchEvent(new CustomEvent('sm:cart:added'));
        if (document.querySelector('cart-drawer, cart-notification')) {
          const drawer = document.querySelector('cart-drawer');
          if (drawer && drawer.open) drawer.open(addBtn);
          else window.location.href = cartUrl;
        } else {
          window.location.href = cartUrl;
        }
      } catch (err) {
        console.error(err);
        if (addText) addText.textContent = labels.tryAgain;
        addBtn.disabled = false;
        addBtn.removeAttribute('aria-disabled');
        addBtn.classList.remove('loading');
        if (addSpinner) addSpinner.hidden = true;
      }
    });
  }
})();
